import React, { useMemo, useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next'
import Select from 'react-select';
import clsx from 'clsx';
import { reactSelectStyles } from 'components/Shared/ReactSelectStyles'

const BlochchainOption = ({ innerRef, innerProps, ...rest }) => {
    const { data, isSelected } = rest;

    const styles = data.locked ? {
        pointerEvents: 'none',
        color: '#aaa'
    } : {}

    return (
        <div 
            className={clsx(
                'd-flex flex-column px-3 py-1 juridistion-select--option text-dark', 
                isSelected && 'active', 
                data.locked && 'disabled'
            )} 
            ref={innerRef} 
            style={styles}
            {...innerProps}
        >
            <div className="align-items-center">
                <img className="signature-icon" src={'/images/blockchain.png'} style={{width: 30}} alt={data.description} />
                <strong className="ml-2">{data.label}</strong>
            </div>
            <small>{data.description}</small>
            {/* <components.Option {...props} /> */}
        </div>
    );
}

export function useBlockchainList() {
    const { t } = useTranslation();

    const blockchainMap = useMemo(() => {
        return new Map([
            ['none', { 
                label: t('editor.config.blockchain_none'), 
                value: 'none', 
                description: '' 
            }],
            ['basic', {
                label: t('editor.config.blockchain_basic'),
                value: 'basic',
                description: t('editor.config.blockchain_basic_description'),
            }],
            ['blockchain2020', {
                label: 'Ethereum (Smart Contract)',
                value: 'blockchain2020',
                description: t('editor.config.ethereum_basic_description'),
            }],
            // ["quorum", {
            //     label: 'Quorum (BETA)',
            //     value: 'certificate',
            //     description: '',
            // }],
            // ["advanced", {
            //     label: 'Blockchain Express',
            //     value: 'certificate',
            //     description: 'Registro en el blockchain de bitcoin con confirmación inmediata. (Costo por registro).',
            // }],
        ])
    }, [t])
    
    return { blockchainMap, blockchainArray: Array.from(blockchainMap.values()) }
}

export function BlockchainSelect({ value, onChange, ...props }) {
    const [realValue, setRealValue] = useState(null); 
    const { blockchainArray, blockchainMap } = useBlockchainList();

    useEffect(() => {
        if (blockchainMap.get(value)) {
            setRealValue(blockchainMap.get(value))
        } else {
            setRealValue(blockchainMap.get('none') || null)
        }
    }, [blockchainMap, value])

    const handleChange = (option) => {
        onChange(option?.value || null, option)
    }


    return <Select 
        components={{ Option: BlochchainOption }}
        options={blockchainArray}
        styles={reactSelectStyles}
        value={realValue}
        onChange={handleChange}
        {...props}
    />
}